import {IssueType} from "../domain/entities/issue-type.entity";
import {AbstractCommand} from "./abstract.command";
import {CommandName} from "./command-name.enum";

export class UpdateIssueTypeCommand extends AbstractCommand<IssueType> {

    public name: CommandName = CommandName.UPDATE_ISSUE_TYPE;

    public tags = ['entity', 'change', 'issue-type'];

    constructor(payload: IssueType) {
        super('issue-type', payload.uid, payload);
    }
}